import React, { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

interface IProps {
    readonly children: ReactNode;
}

function Header({ children }: IProps) {
    const classes = useStyles();
    return <div className={classes.root}>{children}</div>;
}

const useStyles = makeStyles((theme: any) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${theme.palette.background.border}`,
        padding: '40px 60px 40px 60px'
    }
}));

export default Header;
